export const findAndAssignField = (schema: any, fieldId: any, value: any) => {
  const field = schema.find((item: any) => item.id === fieldId)
  if (field) {
    field.filteredValue = value
    field.disabled = value == null // == para comprobar tanto undefined como null
  }
  return field
}

export const toggleFieldVisibility = (_formData: any, schema: any, fieldId: string, visibility: boolean): void => {
  const field = schema.find((item: any) => item.id === fieldId)
  if (!field) {
    return
  }
  if (visibility) {
    field.hidden = field.disabled = false
    field.validationRules = 'required'
  } else {
    field.hidden = field.disabled = true
    field.validationRules = null
  }
}

export const toggleFieldEnable = (_formData: any, schema: any, fieldId: string, enable: boolean): void => {
  const field = schema.find((item: any) => item.id === fieldId)
  if (!field) {
    return
  }
  if (enable) {
    field.disabled = false
    field.validationRules = 'required'
  } else {
    field.disabled = true
    field.validationRules = null
  }
}

export const updateDisabledFields = (formFields: any, formData: any, fieldsToValidate: any, forceDisable: boolean = false) => {
  formFields.forEach((field: any) => {
    if (fieldsToValidate.includes(field.id)) {
      if (field.disabled && formData[field.id] != null) {
        field.disabled = false
      }
      if (forceDisable) {
        field.disabled = true
      }
    }
  })
  return formFields
}

